import { render, staticRenderFns } from "./SlideColProduct.vue?vue&type=template&id=3f6c243e&lang=html"
import script from "./SlideColProduct.vue?vue&type=script&lang=js"
export * from "./SlideColProduct.vue?vue&type=script&lang=js"
import style0 from "./SlideColProduct.vue?vue&type=style&index=0&id=3f6c243e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports